import './MediaList.scss';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { SonarText } from '@ui/text';
import { useParams } from 'react-router-dom';
import { convertISODateToHumanReadableDate, getDisplayUrl } from '@sonar-software/sonar-ts-lib';
import { coreActions, getInitiativeFile } from '@sonar-software/sonar-core';
import { DeleteFilled, EditOutlined } from '@ant-design/icons';
import { List, Popconfirm, Row } from 'antd';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser, useDownload } from '@hooks';
export const InitiativeMediaListItem = ({ listItem, setSelectedItem }) => {
    const { isReadOnly } = useCurrentUser();
    const isFile = Boolean(listItem.contentType);
    const params = useParams();
    const initiativeId = Number(params.id);
    const deleteAction = useAction(isFile ?
        coreActions.requestDeleteCoreInitiativesFilesById :
        coreActions.requestDeleteCoreInitiativesLinksById);
    const handleDeleteConfirm = () => deleteAction({
        id: listItem.id,
        initiativeId
    });
    const downloadRequest = useCallback(() => getInitiativeFile({
        fileId: listItem.id,
        initiativeId
    }), [initiativeId, listItem.id]);
    const download = useDownload();
    const handleEditClick = () => setSelectedItem(listItem);
    const handleDownloadClick = useCallback(() => {
        download({
            errorMessage: NOTIFICATIONS_COPY.ERROR_DOWNLOAD_INITIATIVE_FILE,
            request: downloadRequest
        });
    }, [download, downloadRequest]);
    const renderFile = (file) => React.createElement("a", { onClick: handleDownloadClick }, file.name);
    const renderLink = (link) => React.createElement("a", { href: link.url, target: '_blank' }, link.title || getDisplayUrl(link.url));
    const editButton = React.createElement("div", { key: 1 },
        React.createElement(EditOutlined, { className: 'edit-button', onClick: handleEditClick }));
    const deleteButton = React.createElement("div", { key: 2 },
        React.createElement(Popconfirm, { cancelText: 'Cancel', okText: 'Delete', okType: 'danger', onConfirm: handleDeleteConfirm, title: 'Are you sure?' },
            React.createElement(DeleteFilled, { className: 'delete-button' })));
    const title = React.createElement(Row, { justify: 'space-between', wrap: false },
        React.createElement(SonarText, { ellipsis: true }, isFile ? renderFile(listItem) : renderLink(listItem)));
    const description = React.createElement(SonarText, { size: 12 }, convertISODateToHumanReadableDate(listItem.addedOn));
    return (React.createElement(List.Item, { actions: isReadOnly ? [] : [editButton, deleteButton], key: listItem.id },
        React.createElement(List.Item.Meta, { description: description, title: title })));
};
